module.exports = {"dropDownPlaceholder":"Iniciar sesión sin un Adobe ID"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/es_es.json
// module id = 928
// module chunks = 0